<template>
    <div class="dispatch">
        <div class="dispatchTitle">
            Dispatch
        </div>
        <div class="dispatchWrapper">
            <div class="groupFields">
                <field
                    :class-error="valid.percent && valid.percent.$error"
                    margin="10px 0 0"
                    width="120px"
                    type="number"
                    label="Rate amount"
                    placeholder="0"
                    :setInputValue="percent"
                    @updateInput="onInput"
                    is-required
                    is-number
                ></field>
                <field
                    margin="10px 0 0 10px"
                    width="270px"
                    label="Sale manager"
                    placeholder="Employee"
                    @updateAutocomplete="onManagerAutocomplete"
                    :autocompleteValue="creator"
                    :items="dispatchersList"
                    is-autocomplete
                ></field>
            </div>
            <dispatch-exception
                @updateExceptionData="onExceptionData"
                :valid="valid"
            ></dispatch-exception>

            <div class="groupFields">
                <div class="groupField">
                    <div class="groupFieldTitle">
                        <span>Dispatchers nicknames</span>
	                    <v-btn
			                    @click="onAddDispatcherItem" type="button"
			                    depressed
			                    class="mainBtn mainBtn-text"
	                    >
		                    <span class="btnIco"><svg-sprite icon-id="addItem" width="20" height="20"></svg-sprite></span>
		                    <span class="btnText">Add dispatcher</span>
	                    </v-btn>
                    </div>
                    <template v-for="(item, idx) in dispatchersNik">
                        <div class="groupField_wrap" :key="idx">
                            <field
                                :class-error="valid.dispatchersNik.$each.$iter[idx]['name'].$error"
                                margin="0 20px 0 0"
                                width="255px"
                                label="Nickname"
                                placeholder="Enter nickname"
                                @updateInput="onDispatcherInput($event)"
                                :setInputValue="item.name"
                                :idx="idx"
                                is-required
                            ></field>
                            <field
                                :class-error="valid.dispatchersNik.$each.$iter[idx]['id'].$error"
                                margin="0 15px 0 0"
                                width="255px"
                                label="Dispatcher name"
                                placeholder="Select dispatcher name"
                                @updateAutocomplete="onDispatcherAutocomplete($event)"
                                :autocompleteValue="item"
                                :items="dispatchersList"
                                :idx="idx"
                                is-autocomplete
                                is-required
                                :is-clearable="false"
                            ></field>
                            <button type="button" class="deleteItem" @click="onDeleteItem(idx, 'dispatchersNik')">
                                <svg-sprite style="color: #19BC38" width="20" height="20" icon-id="deleteItem"></svg-sprite>
                            </button>
                        </div>
                    </template>
                </div>
            </div>

            <dnu
                :valid="valid"
                :brokers="brokers"
                :dnu="dnu"
                @updateDnuList="onDnuList"
            ></dnu>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
// components
import DispatchException
from "@/components/Maintenance/Customer/CustomerForm/SecondTab/Dispatch/DispatchException/DispatchException";
import Dnu from "@/components/Maintenance/Customer/CustomerForm/SecondTab/Dispatch/Dnu/Dnu";

export default {
	name: "Dispatch",
	components: {
		DispatchException,
		Dnu,
	},
	props: {
		dispatchersList: Array,
		dnu: Array,
		brokers: Array,
		valid: Object,
		serviceList: Object,
		percent: [ String, Number ]
	},
	computed: mapGetters([ 'customersList' ]),
	data: () => ({
		dispatchersNik: [],
		creator: null,
		exceptionList: []
	}),
	methods: {
		onDnuList(value) {
			this.$emit('updateDnuList', value);
		},
		getData() {
			this.$emit('updateDispatchData', { ...this.$data });
		},
		onDispatcherAutocomplete({ value, idx }) {
			const defaultValue = {
				id: null,
				name: null,
				personal_name: null
			};

			if (value) {
				value = { id: value.id, personal_name: value.value, name: this.dispatchersNik[idx].name };
			}

			const item = value ?? defaultValue;

			this.dispatchersNik.splice(idx, 1, item);
			this.getData();
		},
		onInput({ value }) {
			this.$emit('updatePercent', { value });
		},
		onDispatcherInput({ value, idx }) {
			this.dispatchersNik[idx]['name'] = value;
			this.getData();
		},
		onExceptionData(exceptionList) {
			this.exceptionList = exceptionList;
			this.getData();
		},
		onManagerAutocomplete({ value }) {
			this.creator = value;
			this.getData();
		},
		onAddDispatcherItem() {
			const value = {
				id: null,
				name: null,
				personal_name: null
			};

			this.dispatchersNik.push(value);
			this.getData();
		},
		onDeleteItem(idx, key) {
			this[key].splice(idx, 1);
			this.getData();
		}
	},
	mounted() {
		const {
			dispatcherNik,
		} = this.customersList;
		this.dispatchersNik = dispatcherNik;
		const { manager, manager_id } = this.serviceList;
		this.creator = { value: manager, id: manager_id };
	}
};
</script>

<style scoped lang="scss">
@import "Dispatch";
</style>
